import React, { useEffect, useRef } from "react";
import { selectVariant } from "../../utils/adVariant";
import { isYandexRefreshable, renderYandex, useAdRefresh } from "../../utils/adRefresh";

export function AdvManager({ isFull, isDesktop, options }) {
    const option = selectVariant(options, isFull, isDesktop);
    const optionObj = Array.isArray(option) ? option[0] : option;
    const blockId = optionObj && optionObj.blockId;
    const ref = useRef(null);
    const round = useAdRefresh(ref, {
        enabled: Boolean(blockId && optionObj.renderTo) && isYandexRefreshable(optionObj.type),
        refreshOnLeave: true,
    });

    useEffect(() => {
        if (!blockId || !window.yaContextCb) {
            return;
        }

        renderYandex(optionObj, ref.current, round);
    }, [blockId, round]);

    if (!optionObj || !optionObj.renderTo) {
        return null;
    }

    return <div ref={ref} id={optionObj.renderTo} />;
}
